import { render, staticRenderFns } from "./ArrivalOrders.vue?vue&type=template&id=6c9117f2&scoped=true"
import script from "./ArrivalOrders.vue?vue&type=script&lang=js"
export * from "./ArrivalOrders.vue?vue&type=script&lang=js"
import style0 from "./ArrivalOrders.vue?vue&type=style&index=0&id=6c9117f2&prod&lang=less&scoped=true"
import style1 from "./ArrivalOrders.vue?vue&type=style&index=1&id=6c9117f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9117f2",
  null
  
)

export default component.exports